/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import {
    ProductPrice as SourceProductPrice
} from 'SourceComponent/ProductPrice/ProductPrice.component';
import { ProductType } from 'Type/ProductList.type';
import { formatPrice, roundDiscount } from 'Util/Price';

import './ProductPrice.override.style';

/** @namespace Elganso/Component/ProductPrice/Component */
export class ProductPriceComponent extends SourceProductPrice {
    static propTypes = {
        ...super.propTypes,
        product: ProductType
    };

    static defaultProps = {
        ...super.defaultProps,
        product: {}
    };

    renderDiscountPercentaje() {
        const {
            discountPercentage
        } = this.props;

        const porcentajeRound = roundDiscount(discountPercentage);

        if (porcentajeRound < 1) {
            return null;
        }
        const porcentajeRoundText = `-${porcentajeRound}%`;

        return (
            <span className="tag_discount">
                { porcentajeRoundText }
            </span>
        );
    }

    renderOldPrice() {
        const {
            price: {
                originalPrice: {
                    value: originalPriceValue,
                    valueFormatted: originalPriceFormatted
                } = {}
            } = {},
            discountPercentage,
            isSchemaRequired,
            variantsCount
        } = this.props;

        if (discountPercentage === 0 || originalPriceValue === 0) {
            return null;
        }

        return (
            <del
              block="ProductPrice"
              elem="HighPrice"
              aria-label={ __('Old product price') }
              itemProp={ isSchemaRequired && variantsCount > 1 ? { itemProp: 'highPrice' } : null }
            >
                { originalPriceFormatted }
            </del>
        );
    }

    renderBundlePrice() {
        const {
            originalPrice: {
                maxFinalPrice = {},
                maxFinalPriceExclTax = {}
            },
            product: {
                bundle_options = null
            }
        } = this.props;

        let totalPrice = 0;

        if (bundle_options !== null && bundle_options.length > 0) {
            bundle_options.map((item) => {
                if (item !== null && item?.selection_details.length > 0) {
                    totalPrice += item?.selection_details[0]?.final_option_price;
                }
            });

            if (totalPrice !== null && totalPrice > 0) {
                maxFinalPrice.value = totalPrice;
                maxFinalPrice.valueFormatted = formatPrice(totalPrice, maxFinalPrice.currency);
            }
        }

        return (
            this.renderPriceWithOrWithoutTax(maxFinalPrice, maxFinalPriceExclTax)
        );
    }

    seeProductDiscount() {
        const { product, skuActivo } = this.props;
        let { sku } = product;
        let contieneDescuento = false;

        if (product.type_id === 'configurable') {
            if (sku !== skuActivo) {
                sku = skuActivo.split('-')[0];
            }

            product.variants.some((element) => {
                if (element.sku.includes(sku)) {
                    if (element.price_range.minimum_price.discount.amount_off !== 0) {
                        contieneDescuento = true;
                        return contieneDescuento;
                    }
                }
            });
        } else if (product.price_range.minimum_price.discount.amount_off !== 0) {
            contieneDescuento = true;
        }

        return contieneDescuento;
    }

    renderPrice(price) {
        const {
            discountPercentage
        } = this.props;

        const {
            value: priceValue,
            valueFormatted: priceFormatted = 0
        } = price;

        let productHaveDiscount = false;

        if (discountPercentage !== 0) {
            productHaveDiscount = this.seeProductDiscount();
        }

        const { itemProp = null, content = null } = this.getCurrentPriceSchema();

        // Use <ins></ins> <del></del> to represent new price and the old (deleted) one
        const PriceSemanticElementName = discountPercentage > 0 ? 'ins' : 'span';

        // force unequal comparison - unsure of resulting type
        if (priceValue === 0) {
            return null;
        }

        if (productHaveDiscount) {
            return (
                <PriceSemanticElementName block="ProductPrice" elem="Price">
                    { this.renderOldPrice() }
                    <span
                      itemProp={ itemProp }
                      content={ content }
                      block="ProductPrice"
                      elem="PriceValue"
                    >
                        { priceFormatted }
                        { this.renderDiscountPercentaje() }
                    </span>
                </PriceSemanticElementName>
            );
        }

        return (
                <PriceSemanticElementName block="ProductPrice" elem="Price">
                    <span
                      itemProp={ itemProp }
                      content={ content }
                      block="ProductPrice"
                      elem="PriceValue"
                    >
                        { priceFormatted }
                    </span>
                </PriceSemanticElementName>
        );
    }

    renderDefaultPrice(defaultLabel = null) {
        const {
            price: {
                finalPrice = {}, finalPriceExclTax = {}, originalPrice = {}, originalPriceExclTax = {}
            } = {},
            label,
            discountPercentage
        } = this.props;

        let productHaveDiscount = false;

        if (discountPercentage !== 0) {
            productHaveDiscount = this.seeProductDiscount();
        }

        if (productHaveDiscount) {
            return (
                <>
                    { this.renderPriceWithOrWithoutTax(finalPrice, finalPriceExclTax, defaultLabel || label) }
                    { this.renderSchema() }
                </>
            );
        }

        return (
            <>
                    { this.renderPriceWithOrWithoutTax(originalPrice, originalPriceExclTax, defaultLabel || label) }
                    { this.renderSchema() }
            </>
        );
    }

    render() {
        const {
            price: {
                finalPrice,
                originalPrice,
                originalPrice: {
                    value: originalPriceValue = 0
                } = {},
                finalPrice: {
                    value: finalPriceValue = 0
                } = {}
            } = {},
            priceType,
            isPreview,
            discountPercentage,
            mix
        } = this.props;

        if (!finalPrice || !originalPrice) {
            return this.renderPlaceholder();
        }

        let productHaveDiscount = false;

        if (discountPercentage !== 0) {
            productHaveDiscount = this.seeProductDiscount();
        }

        const { [priceType]: renderer } = this.pricePreviewRenderMap;

        return (
            <div
              block="ProductPrice"
              mods={ { hasDiscount: discountPercentage !== 0, isPreview } }
              mix={ mix }
              aria-label={ `Product price: ${productHaveDiscount ? finalPriceValue : originalPriceValue }` }
            >
                { isPreview && renderer && renderer() }
                { (!isPreview || !renderer) && this.renderDefaultPrice() }
            </div>
        );
    }
}

export default ProductPriceComponent;
